/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { LeadTaskWorkflowItemCreationSource } from './LeadTaskWorkflowItemCreationSource';
import {
    LeadTaskWorkflowItemCreationSourceFromJSON,
    LeadTaskWorkflowItemCreationSourceFromJSONTyped,
    LeadTaskWorkflowItemCreationSourceToJSON,
    LeadTaskWorkflowItemCreationSourceToJSONTyped,
} from './LeadTaskWorkflowItemCreationSource';
import type { TaskWorkflowItemStatus } from './TaskWorkflowItemStatus';
import {
    TaskWorkflowItemStatusFromJSON,
    TaskWorkflowItemStatusFromJSONTyped,
    TaskWorkflowItemStatusToJSON,
    TaskWorkflowItemStatusToJSONTyped,
} from './TaskWorkflowItemStatus';
import type { LeadTaskWorkflowItemAssignee } from './LeadTaskWorkflowItemAssignee';
import {
    LeadTaskWorkflowItemAssigneeFromJSON,
    LeadTaskWorkflowItemAssigneeFromJSONTyped,
    LeadTaskWorkflowItemAssigneeToJSON,
    LeadTaskWorkflowItemAssigneeToJSONTyped,
} from './LeadTaskWorkflowItemAssignee';

/**
 * 
 * @export
 * @interface LeadTaskWorkflowItem
 */
export interface LeadTaskWorkflowItem {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    task_workflow_item_id: string | null;
    /**
     * 
     */
    task_workflow_item_org_configuration_id: string | null;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    display_order: number;
    /**
     * 
     */
    status: TaskWorkflowItemStatus;
    /**
     * 
     */
    assignee: LeadTaskWorkflowItemAssignee | null;
    /**
     * 
     */
    creation_source: LeadTaskWorkflowItemCreationSource;
    /**
     * Non-deleted comments tagged to this item, replies included.
     */
    comment_count: number;
    /**
     * 
     */
    completed_at: Date | null;
    /**
     * 
     */
    assigned_at: Date | null;
    /**
     * 
     */
    status_changed_at: Date | null;
    /**
     * 
     */
    last_activity_at: Date;
    /**
     * 
     */
    date_created: Date;
}



/**
 * Check if a given object implements the LeadTaskWorkflowItem interface.
 */
export function instanceOfLeadTaskWorkflowItem(value: object): value is LeadTaskWorkflowItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('task_workflow_item_id' in value) || value['task_workflow_item_id'] === undefined) return false;
    if (!('task_workflow_item_org_configuration_id' in value) || value['task_workflow_item_org_configuration_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('display_order' in value) || value['display_order'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    if (!('creation_source' in value) || value['creation_source'] === undefined) return false;
    if (!('comment_count' in value) || value['comment_count'] === undefined) return false;
    if (!('completed_at' in value) || value['completed_at'] === undefined) return false;
    if (!('assigned_at' in value) || value['assigned_at'] === undefined) return false;
    if (!('status_changed_at' in value) || value['status_changed_at'] === undefined) return false;
    if (!('last_activity_at' in value) || value['last_activity_at'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    return true;
}

export function LeadTaskWorkflowItemFromJSON(json: any): LeadTaskWorkflowItem {
    return LeadTaskWorkflowItemFromJSONTyped(json, false);
}

export function LeadTaskWorkflowItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadTaskWorkflowItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'task_workflow_item_id': json['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': json['task_workflow_item_org_configuration_id'],
        'name': json['name'],
        'display_order': json['display_order'],
        'status': TaskWorkflowItemStatusFromJSON(json['status']),
        'assignee': LeadTaskWorkflowItemAssigneeFromJSON(json['assignee']),
        'creation_source': LeadTaskWorkflowItemCreationSourceFromJSON(json['creation_source']),
        'comment_count': json['comment_count'],
        'completed_at': (json['completed_at'] == null ? null : parseDateTime(json['completed_at'])),
        'assigned_at': (json['assigned_at'] == null ? null : parseDateTime(json['assigned_at'])),
        'status_changed_at': (json['status_changed_at'] == null ? null : parseDateTime(json['status_changed_at'])),
        'last_activity_at': (json['last_activity_at'] == null ? json['last_activity_at'] : parseDateTime(json['last_activity_at'])),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
    };
}

export function LeadTaskWorkflowItemToJSON(json: any): LeadTaskWorkflowItem {
    return LeadTaskWorkflowItemToJSONTyped(json, false);
}

export function LeadTaskWorkflowItemToJSONTyped(value?: LeadTaskWorkflowItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'task_workflow_item_id': value['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': value['task_workflow_item_org_configuration_id'],
        'name': value['name'],
        'display_order': value['display_order'],
        'status': TaskWorkflowItemStatusToJSON(value['status']),
        'assignee': LeadTaskWorkflowItemAssigneeToJSON(value['assignee']),
        'creation_source': LeadTaskWorkflowItemCreationSourceToJSON(value['creation_source']),
        'comment_count': value['comment_count'],
        'completed_at': value['completed_at'] == null ? value['completed_at'] : serializeDateTime(value['completed_at']),
        'assigned_at': value['assigned_at'] == null ? value['assigned_at'] : serializeDateTime(value['assigned_at']),
        'status_changed_at': value['status_changed_at'] == null ? value['status_changed_at'] : serializeDateTime(value['status_changed_at']),
        'last_activity_at': value['last_activity_at'] == null ? value['last_activity_at'] : serializeDateTime(value['last_activity_at']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
    };
}

